import styled, { css } from 'styled-components'
import { InputLabel, Typography } from '@material-ui/core'

const INPUT_HEIGHT = 108

export const inputStyle = css`
	display: none;
`

export const uploadButtonStyle = css`
	height: ${INPUT_HEIGHT}px;
	width: 100%;
	cursor: pointer;

	display: flex;
	padding: 10px 12px;
	align-items: center;
	gap: 10px;
	align-self: stretch;
	border-radius: 16px;
	border: 1px solid ${({ theme }) => theme.colors.background.element.dark};
	background-color: ${({ theme }) => theme.colors.background.app.light};

	&:hover {
		background-color: ${({ theme }) => theme.palette.secondary.sub};
		border-radius: 8px;
	}

	justify-content: start;
	text-transform: unset;

	.content {
		margin-left: 52px;
		.MuiTypography-caption {
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			display: block;
		}
	}
`

export const imageBoxStyle = css`
	position: absolute;
	top: 0;
	left: 0;
	cursor: pointer;
	.container {
		display: flex;
		cursor: pointer;
		justify-content: center;
		align-items: center;
		gap: 10px;
		height: ${INPUT_HEIGHT}px;
		.icon {
			border-radius: 50%;
			width: 60px;
			height: 60px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		svg {
			fill: none;
		}
		.upload-comp {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			height: 60px;

			.upload-comp-title {
				color: ${({ theme }) => theme.colors.background.element.dark};
				${({ theme }) => theme.typography.title1}
			}
			.upload-comp-sub-title {
				margin-top: auto;
				color: ${({ theme }) => theme.colors.content.dark};
				${({ theme }) => theme.typography.body2}
			}
		}
	}
`

export const imageBoxUploadStyle = css`
	margin-left: 4px;
	cursor: pointer;
	.container {
		display: flex;
		cursor: pointer;
		justify-content: center;
		align-items: center;
		svg {
			font-size: 25px;
		}
	}
`

export const wrapperStyle = css`
	width: 100%;
`

export const itemBoxStyle = css`
	align-items: center;
	width: 100%;
	height: 52px;
	position: relative;
	background: ${({ theme }) => theme.colors.background.element.veryLight};
	color: ${({ theme }) => theme.colors.content.veryDark};
	border-radius: 8px;
	cursor: pointer;
	padding: 4px 12px;
	display: flex;

	.MuiIconButton-root {
		margin-left: auto;
	}

	.file {
		margin-left: 12px;
		display: flex;
		flex-direction: column;

		.file__name {
			overflow: hidden;
			display: block;
			text-overflow: ellipsis;
			white-space: nowrap;
			${({ theme }) => theme.typography.subtitle2}
		}

		.file__size {
			color: ${({ theme }) => theme.colors.content.dark};
			${({ theme }) => theme.typography?.body3}
		}
	}

	.preview-image {
		img {
			height: 30px;
			width: 30px;
			overflow: hidden;
			border-radius: 8px;
		}
	}

	.lazyload-wrapper {
		width: 28px;
		height: 28px;
		border-radius: 50%;
		overflow: hidden;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}
`

export const filenameStyle = css`
	overflow: hidden;
	display: block;
	text-overflow: ellipsis;
	white-space: nowrap;
	${({ theme }) => theme.typography.subtitle2}
`

export const titleStyle = css`
	font-style: normal;
	font-weight: 800;
	font-size: 14px;
	line-height: 18px;

	letter-spacing: 0.1px;
	color: #0e3f6c;
`

export const messageStyle = css`
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 18px;

	letter-spacing: 0.1px;

	color: #0e3f6c;
`

export const uploadInputStyled = css`
	position: relative;
	width: 100%;
	height: 100%;
`

export const labelStyle = css`
	margin-bottom: 12px;
	${({ theme }) => theme.typography.subtitle2}
	color: ${({ theme }) => theme.palette.primary.main};
`

export const loadingButtonStyle = css`
	height: 80px;
	width: 80px;
	background: white;
	border: 1px solid #e6e6e6;
	box-sizing: border-box;
	border-radius: 8px;
	justify-content: center;
	display: flex;
	align-items: center;
`

export const pdfCarouselButton = css`
	height: 100%;
	width: 100%;
	background: white;
	justify-content: center;
	display: flex;
	align-items: center;
`

export const fileNameElisips = css`
	font-size: 12px;
	line-height: 18px;
	text-align: center;
`

export const WrapperSliderBox = styled.div`
	display: flex;
	overflow: auto;
	max-width: calc(100vw - 450px);
	@media (max-width: 1065px) {
		max-width: calc(100vw - 350px);
	}
	@media (max-width: 960px) {
		max-width: 90vw;
	}
	@media (max-width: 650px) {
		max-width: 87vw;
	}
	@media (max-width: 600px) {
		max-width: 85vw;
	}
`

export const WrapperInputLabel = styled(InputLabel)`
	padding: 5px 0;
`

export const WrapperSubtitile = styled(Typography)`
	font-size: 12px;
	font-weight: 400;
	color: #808080;
	line-height: 18px;
	padding: 5px 0;
`
export const WrapperButton = styled.div`
	padding: 10px 10px 10px 0;
`

export const previewFileWrapper = css`
	:has(.MuiCollapse-entered) {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}
`
